import QueryStore from './QueryStore';
import RootStore from './RootStore';
import ToastManagerStore from './ToastManager';

export const store = new RootStore();
export const queryStore = new QueryStore();
export const toastManager = new ToastManagerStore();
